// /**
//  * Center - Add
//  */

// React
import React, {useState} from 'react';

// react hook form
import {useForm} from 'react-hook-form';

// Client SDK
import Client from 'client-sdk/src/client';
import {GetAllUsersRequestBuilder} from 'client-sdk/src/users/users';

// UI
import {
  TextField,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccount,
  mdiCellphone,
  mdiHomeCityOutline,
  mdiMapMarkerOutline,
  mdiPhone,
  mdiPostOutline,
  mdiStore,
  mdiStore24Hour,
} from '@mdi/js';

// Component
import MapPosition from './mapPosition';

// Type
import {Center, Supervisor} from '../interfaces';
import {User} from '../../users/interfaces';
import {control} from 'leaflet';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    text: {
      width: '100%',
    },
    errorText: {
      color: '#F30000',
      fontSize: '11px',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '12px',
      marginTop: '21px',
    },
  })
);

type Props = {
  create: (body: Center, callback: () => void) => void;
  close: () => void;
  partnerId: number;
  supervisorsList: Supervisor[];
};

type Inputs = {
  name: string;
  code: string;
  admin: object;
  phoneNumber: number;
  province: string;
  city: string;
  zipCode: string;
  address: string;
};

export default function Add(props: Props) {
  const {register, handleSubmit, errors} = useForm<Inputs>({
    mode: 'onChange',
  });
  const [open, setOpen] = useState(false as boolean);
  const [adminId, setAdminId] = useState(0 as number);
  const [supervisorId, setSupervisorId] = useState(null as number | null);
  const [latLng, setLatLng] = useState({lat: 0, lng: 0} as {
    lat: number;
    lng: number;
  });
  const classes = useStyles();

  const [
    openAutocompleteSupervisors,
    setOpenAutocompleteSupervisors,
  ] = React.useState(false);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [options, setOptions] = React.useState<User[]>([]);
  const loading = openAutocomplete && options.length === 0;

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllUsersRequestBuilder()
        .params({
          'role.equals': 'CENTER_ADMIN',
          'centersId.specified': false,
          size: 100,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const users = response.data as any;
      if (active) {
        setOptions(users as User[]);
      }
      if (users.length === 0) {
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]);

  const onSubmit = (data: any) => {
    const {partnerId} = props;

    const {name, phoneNumber, zipCode, address, city, province, code} = data;
    const {lat, lng} = latLng;
    props.create(
      {
        name: name.trim(),
        phoneNumber: phoneNumber.length > 0 ? phoneNumber : null,
        address,
        code,
        partnerId,
        city: city.trim(),
        province: province.trim(),
        zipCode,
        lat,
        lon: lng,
        supervisorId,
        status: 'ACTIVE',
      },
      () => props.close()
      // reset({
      //   ...getValues(),
      //   name: '',
      //   address: '',
      // })
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={5} alignItems="flex-start">
        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiStore} size={1} />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="name"
                name="name"
                label="نام مرکز"
                inputRef={register({
                  required: true,
                  minLength: 5,
                  maxLength: 25,
                })}
                error={errors.name && true}
              />
              {errors.name && errors.name.type === 'required' && (
                <p className={classes.errorText}>{'فیلد نام مرکز الزامیست'}</p>
              )}
              {errors.name && errors.name.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار نام مرکز نباید کمتر از 5 کاراکتر باشد'}
                </p>
              )}
              {errors.name && errors.name.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار نام مرکز نباید بیشتر از 25 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiStore24Hour} size={1} />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="code"
                name="code"
                label="کد مرکز"
                inputRef={register({
                  required: true,
                  minLength: 1,
                  maxLength: 50,
                })}
                error={errors.code && true}
              />
              {errors.code && errors.code.type === 'required' && (
                <p className={classes.errorText}>{'فیلد کد مرکز الزامیست'}</p>
              )}
              {errors.code && errors.code.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار کد مرکز نباید کمتر از 1 کاراکتر باشد'}
                </p>
              )}
              {errors.code && errors.code.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار کد مرکز نباید بیشتر از 50 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPhone}
                style={{transform: 'scale(-1, 1)'}}
                size={1}
              />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="phoneNumber"
                name="phoneNumber"
                label="شماره تماس"
                inputRef={register({
                  required: true,
                  minLength: 6,
                  maxLength: 15,
                  pattern: /^([+]+98|0)\d{5,10}$/g,
                })}
                error={errors.phoneNumber && true}
              />
              {errors.phoneNumber && errors.phoneNumber.type === 'required' && (
                <p className={classes.errorText}>
                  {'فیلد شماره تماس الزامیست'}
                </p>
              )}
              {errors.phoneNumber && errors.phoneNumber.type === 'pattern' && (
                <p className={classes.errorText}>
                  {'فرمت فیلد شماره تماس صحیح نیست'}
                </p>
              )}
              {errors.phoneNumber &&
                errors.phoneNumber.type === 'minLength' && (
                  <p className={classes.errorText}>
                    {'مقدار شماره تماس نباید کمتر از 11 کاراکتر باشد'}
                  </p>
                )}
              {errors.phoneNumber &&
                errors.phoneNumber.type === 'maxLength' && (
                  <p className={classes.errorText}>
                    {'مقدار شماره تماس نباید بیشتر از 15 کاراکتر باشد'}
                  </p>
                )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPostOutline}
                style={{transform: 'scale(-1, 1)'}}
                size={1}
              />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="zipCode"
                name="zipCode"
                label="کد پستی"
                inputRef={register({
                  required: true,
                  minLength: 10,
                  maxLength: 10,
                  pattern: /^\d{10}$/g,
                })}
                error={errors.zipCode && true}
              />
              {errors.zipCode && errors.zipCode.type === 'required' && (
                <p className={classes.errorText}>{'فیلد کد پستی الزامیست'}</p>
              )}
              {errors.zipCode && errors.zipCode.type === 'pattern' && (
                <p className={classes.errorText}>
                  {'فرمت فیلد کد پستی صحیح نیست'}
                </p>
              )}
              {errors.zipCode && errors.zipCode.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار کد پستی نباید کمتر از 10 کاراکتر باشد'}
                </p>
              )}
              {errors.zipCode && errors.zipCode.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار کد پستی نباید بیشتر از 10 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiHomeCityOutline} size={1} />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="province"
                name="province"
                label="استان"
                inputRef={register({
                  required: false,
                  minLength: 2,
                  maxLength: 20,
                })}
                error={errors.province && true}
              />
              {errors.province && errors.province.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار استان نباید کمتر از 2 کاراکتر باشد'}
                </p>
              )}
              {errors.province && errors.province.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار استان نباید بیشتر از 20 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiHomeCityOutline} size={1} />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="city"
                name="city"
                label="شهر"
                inputRef={register({
                  required: false,
                  minLength: 2,
                  maxLength: 20,
                })}
                error={errors.city && true}
              />
              {errors.city && errors.city.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار شهر نباید کمتر از 2 کاراکتر باشد'}
                </p>
              )}
              {errors.city && errors.city.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار شهر نباید بیشتر از 20 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>

        <Grid container item xs={12} spacing={1} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiMapMarkerOutline} size={1} />
            </span>
            <span className={classes.text}>
              <TextField
                fullWidth
                id="address"
                name="address"
                label="آدرس"
                inputRef={register({
                  required: true,
                  minLength: 10,
                  maxLength: 200,
                })}
                error={errors.address && true}
              />
              {errors.address && errors.address.type === 'required' && (
                <p className={classes.errorText}>{'فیلد آدرس الزامیست'}</p>
              )}
              {errors.address && errors.address.type === 'minLength' && (
                <p className={classes.errorText}>
                  {'مقدار آدرس نباید کمتر از 10 کاراکتر باشد'}
                </p>
              )}
              {errors.address && errors.address.type === 'maxLength' && (
                <p className={classes.errorText}>
                  {'مقدار آدرس نباید بیشتر از 200 کاراکتر باشد'}
                </p>
              )}
            </span>
          </div>
        </Grid>
      </Grid>
      <Grid xs={12} style={{margin: '30px 0'}}>
        <div>
          <MapPosition
            style={{height: '300px'}}
            zoom={14}
            center={{lat: 35.6892, lng: 51.389}}
            position={latLng}
            setLatlng={(latLng: {lat: number; lng: number}) => {
              setLatLng(latLng);
            }}
          />
        </div>
      </Grid>
      <Grid
        container
        item
        xs={12}
        spacing={3}
        alignItems="center"
        style={{margin: '30px 0'}}
      >
        <Grid item xs={6}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            size="large"
            data-cy="search"
          >
            {`ایجاد مرکز جدید`}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            type="button"
            fullWidth
            variant="contained"
            size="large"
            data-cy="search"
            onClick={props.close}
          >
            {`بستن`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
